import * as types from './types';

const initialState = {
  noteTemplateFolders: [],
};

export default (state = initialState, action) => {
  const { templateFolder } = action.payload || {};
  switch (action.type) {
    case types.GET_NOTE_TEMPLATE_FOLDERS:
      return state;
    case types.GET_NOTE_TEMPLATE_FOLDERS_SUCCESS:
      return { ...state, noteTemplateFolders: action.payload };
    case types.GET_NOTE_TEMPLATE_FOLDERS_FAIL:
      return state;
    case types.CREATE_NOTE_TEMPLATE_FOLDER:
      return state;
    case types.CREATE_NOTE_TEMPLATE_FOLDER_SUCCESS:
      return state;
    case types.CREATE_NOTE_TEMPLATE_FOLDER_FAIL:
      return state;
    case types.UPDATE_NOTE_TEMPLATE_FOLDER_SUCCESS:
      return {
        ...state,
        noteTemplateFolders: state.noteTemplateFolders.map(item => {
          return item.id === templateFolder.id ? { ...item, name: templateFolder.name } : item;
        }),
      };
    default:
      return state;
  }
};
